"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShowHideHidden = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
/**
 * A ShowHideHidden component is used to toggle one or multiple
 * parts of items in `ShowHide` component.
 *
 * @since 8.36.0
 */
var ShowHideHidden = function ShowHideHidden(props) {
  var isHidden = props.isHidden,
    children = props.children;
  if (isHidden) {
    return null;
  }

  // eslint-disable-next-line zillow/react/jsx-no-useless-fragment
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children);
};
exports.ShowHideHidden = ShowHideHidden;
ShowHideHidden.displayName = 'ShowHideHidden';
ShowHideHidden.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The visibility of the content will be controlled by `isHidden`.
   */
  children: _propTypes.default.node,
  /**
   * Flag to display children content.
   */
  isHidden: _propTypes.default.bool
} : {};